class AbstractClass {

    object = null;
    type = null;

    constructor() {
        return this;
    }

    create = (props = {}) => {
        this.type = props.type;
        this.object = props.object;
        return this;
    }

    isNewTarget = () => {
        return this.getID() ? false : true;
    }

    isSame = abstract => {
        return this.getTag() === abstract.getTag();
    }

    getType = () => {
        return this.type;
    }

    getTag = () => {
        return `${this.type}-${this.getID()}`;
    }

    getID = () => {
        return this.type === 'users' ? this.object.user_id : this.object.id
    }

    getTitle = () => {

        switch(this.type) {

            case 'outbound_calls':
            if(this.object.lead_full_name) {
                return `${this.object.method === 'email' ? 'Email' : 'Phone Call'} for ${this.object.lead_full_name}`;
            }
            if(this.object.lead_id) {
                return `${this.object.method === 'email' ? 'Email' : 'Phone Call'} for Lead #${this.object.lead_id}`;
            }
            return `${this.object.method === 'email' ? 'Email' : 'Phone Call'}`;

            case 'appointments':
            if(this.object.lead && this.object.lead.full_name) {
                return `Appointment for ${this.object.lead.full_name}`
            }
            return this.object.id ? `Appointment #${this.object.id}` : 'New Appointment';

            case 'clients':
            return this.object.id ? `"${this.object.name}" Client` : 'New Client';

            case 'events':
            return this.object.id ? `${this.object.title} ${this.object.type.title} Event` : 'New Event';

            case 'event_types':
            return this.object.id ? `${this.object.title} Event Type` : 'New Event Type';

            case 'feedback_responses':
            return `Customer Response from ${this.object.full_name}`;

            case 'feedback_template':
            return this.object.id ? `"${this.object.title}" Feedback Template` : 'New Feedback Template';

            case 'leads':
            return this.object.id ? `Lead${this.object.full_name ? ` for ${this.object.full_name}` : ''}` : 'New Lead';

            case 'lead_scripts':
            return this.object.id ? `${this.object.title}` : 'New Lead Script';

            case 'lead_script_rebuttals':
            return this.object.id ? `"${this.object.title}" Lead Script Rebuttal` : 'New Lead Script Rebuttal';

            case 'lead_transfers':
            return this.object.lead ? this.object.lead.full_name : 'Name unavailable';

            case 'lead_types':
            return this.object.id ? `${this.object.text}` : 'New Lead Type';

            case 'locations':
            return this.object.id ? `Location "${this.object.name}"` : 'New Location';

            case 'notifications':
            return this.object.title;

            case 'surveys':
            return this.object.name;

            case 'status':
            return this.object.code ? this.object.text : 'New Status';

            case 'system_events':
            return `Event #${this.object.id}`;

            case 'templates':
            return this.object.id ? `"${this.object.title}" Template` : 'New Template';

            case 'users':
            if(this.object && this.object.full_name) {
                return this.object.full_name;
            }
            return this.object.user_id ? `User Account #${this.object.user_id}` : 'New User Account';

            default:
            return this.type || 'Unknown Object';
        }
    }

    isSame = abstract => {
        return this.getTag() === abstract.getTag();
    }
}
export default {
    create: props => new AbstractClass().create(props)
};

export const buildTag = (props) => {

    let so = new AbstractClass();
    so.type = props.type;
    so.object = props.object || {
        ...(props.type !== 'users' ? {
            id: props.id
        }:{
            user_id: props.id
        })
    }
    return so.getTag();
}
